define('components/handlers/kyc-report/add-custom-note',[
    'jquery',
], function ($) {
    $.extend(companyInfo.handlers, {
        'add-custom-note': function () {
            var textInput = $("#custom-note-input");
            var dossierID = $('input[name="dossier-id"]').first().val();
            var subDossierID = $('input[name="sub-dossier-id"]').first().val();
            var note = textInput.val();

            fetch('/kyc/reports/' + dossierID + '/documents/custom-notes', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    text: note,
                    subDossierID: subDossierID
                })
            }).then(function (response) {
                if(response.ok) {
                    // insert child record, last input goes first
                    var container = document.getElementById("kyc-report-custom-notes-panel");
                    var date = getTodayDateFormatted();
                    var html = '<div class="custom-note-output"><div class="custom-note-date">' + date + '</div><div class="custom-note-text">' + note + '</div></div>';
                    container.insertAdjacentHTML("beforeend", html);
                    textInput.val('');
                }
            }).catch(function (err) {
                // todo; what to do in case of error?
            });

            function getTodayDateFormatted() {
                var date = new Date();
                var day = String(date.getDate()).padStart(2, '0');
                var month = String(date.getMonth() + 1).padStart(2, '0');
                var year = date.getFullYear();

                return day + '.' + month + '.' + year;
            }

        }
    });

});

